import { UPDATE_PARKING_MARKER_DATA } from "./parkingMarkerDataReducer"

export const updateParkingMarkerData = (info) => async (dispatch) => {
    dispatch({
        type: UPDATE_PARKING_MARKER_DATA,
        payload: info
    })
}